<mat-card-content class="clearfix card" [ngClass]="{ readActivityDisable: data && data.readflag }">
  <form name="updateOfferForm" #f="ngForm">
    <!-- test div to fire validation -->
    <div class="row mt-3" style="margin: auto">
      <div class="col-md-6 mt-2">
        <mat-form-field class="dateField">
          <mat-label>Date of Joining</mat-label>
          <input
            class="dataField"
            required
            (dateChange)="dateChange($event, dojContent)"
            [min]="today"
            [(ngModel)]="doj"
            name="dojs"
            matInput
            [matDatepicker]="picker"
            [value]="doj"
          />
          <mat-icon matSuffix>
            <img src="assets/images/icons/purple_icons/icon-calendar.png" (click)="picker.open()" alt="icon-calendar" />
          </mat-icon>
          <mat-datepicker #picker touchUi></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-md-6 mt-1" *ngIf="showField">
        <mat-form-field class="custom-form-field">
          <mat-label>PU</mat-label>
          <input
            required
            matInput
            [matAutocomplete]="auto"
            name="PU"
            [(ngModel)]="pu"
            [value]="pu"
            (keyup)="getAllPu()"
            (input)="pu = $event.target.value"
          />
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="puChanged($event)">
            <mat-option *ngFor="let pu of puArray" [value]="pu.value">
              {{ pu.value }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <div *ngIf="!puValidate" class="mat-caption">
          <mat-error>Invalid PU</mat-error>
        </div>
      </div>
    </div>
    <div class="row mt-3" style="margin: auto" *ngIf="showField">
      <div class="col-md-6 mt-2">
        <mat-form-field class="custom-form-field" class="dateField">
          <mat-label>Location of posting</mat-label>
          <input
            required
            matInput
            [matAutocomplete]="autoC"
            name="locations"
            [(ngModel)]="location"
            [value]="location"
            (input)="location = $event.target.value"
            (keyup)="getAllCities()"
          />
          <mat-autocomplete #autoC="matAutocomplete" (optionSelected)="locationChange($event)">
            <mat-option *ngFor="let city of cityA" [value]="city.value">
              {{ city.value }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <div *ngIf="!locationValidate" class="mat-caption">
          <mat-error>Invalid Location</mat-error>
        </div>
      </div>
      <div class="col-md-6 mt-1">
        <mat-form-field class="custom-form-field">
          <mat-label>Establishment Type</mat-label>
          <mat-select
            (selectionChange)="changeEstablishment(establishment)"
            required
            name="establishmentTypes"
            [(ngModel)]="establishment"
            [value]="establishment"
          >
            <mat-option *ngFor="let est of estalishmentArray" [value]="est.value"> {{ est.value }} </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-md-12 mt-1" *ngIf="compHiringType == 1">
        <mat-form-field class="custom-form-field" style="width: 100%" appearance="fill">
          <mat-label>Joining Address</mat-label>
          <input matInput name="joiningAddress" [(ngModel)]="joiningAddress" [value]="joiningAddress" readonly />
        </mat-form-field>
      </div>
      <div class="col-md-6 mt-1">
        <mat-form-field class="custom-form-field">
          <mat-label>Category</mat-label>
          <mat-select (selectionChange)="changeCategory(category)" required name="categoryTypes" [(ngModel)]="category">
            <mat-option *ngFor="let cat of categories" [value]="cat">
              {{ cat.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <ng-container *ngIf="compHiringType == 1">
        <div class="col-md-6 mt-1">
          <mat-form-field class="custom-form-field">
            <mat-label>Account Name</mat-label>
            <input
              matInput
              [matAutocomplete]="account"
              [(ngModel)]="accountName"
              (input)="onAccountNameInputChange($event)"
              name="accountName"
              required
            />
            <mat-autocomplete #account="matAutocomplete" (optionSelected)="onAccountNameSelected($event)">
              <mat-option *ngFor="let option of filteredAccountNames" [value]="option.value">{{
                option.value
              }}</mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-error *ngIf="invalidAccountName">Select a valid Account Name</mat-error>
        </div>
      </ng-container>
    </div>
    <div class="row" style="margin: auto">
      <div class="col-md-10">
        <mat-form-field class="custom-form-field">
          <input
            #toValue
            matInput
            placeholder="To"
            required
            name="toInput"
            [value]=""
            [disabled]="toDisable"
            (input)="toInputValue = $event.target.value"
            [(ngModel)]="toInputValue"
          />
        </mat-form-field>
      </div>
      <button mat-icon-button class="text-btn" name="ccbtn" (click)="ccEnableDisable()" style="font-size: 16px">
        CC
      </button>
    </div>
    <div class="col-md-6 mt-1" *ngIf="compHiringType == 4">
      <mat-form-field class="custom-form-field">
        <mat-label>Reason for DOJ change</mat-label>
        <mat-select
          [disabled]="!changedDoj"
          (selectionChange)="changeDojCategory(doj_reason)"
          required
          name="doj_reasonTypes"
          [(ngModel)]="doj_reason"
        >
          <mat-option *ngFor="let dojRes of doj_changeReason" [value]="dojRes">
            {{ dojRes.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-12 mt-1" *ngIf="enableReason">
      <mat-form-field class="custom-form-field">
        <input
          id="rem_"
          matInput
          placeholder="Reason"
          name="doj_remark"
          required
          [(ngModel)]="doj_remarks"
          [value]="doj_remarks"
          (change)="changeDojCategory(doj_reason)"
          (input)="doj_remarks = $event.target.value"
        />
      </mat-form-field>
    </div>
    <div style="margin-left: 15px">
      <mat-form-field class="custom-form-field" [ngStyle]="{ visibility: ccEnable ? 'visible' : 'hidden' }">
        <input
          matInput
          placeholder="CC"
          name="ccinput"
          [(ngModel)]="ccMail"
          [value]="ccMail"
          (input)="ccMail = $event.target.value"
        />
      </mat-form-field>
    </div>
    <div style="margin-left: 15px" *ngIf="offerValidationExpired">
      <p style="color: red; width: 700px">
        Please select approver mail address and doj_validity_attachment as DOJ is beyond offer validity
      </p>

      <mat-form-field class="custom-form-field" class="custom-form-field">
        <mat-label>Email</mat-label>
        <mat-select required name="emailApprovalOption" [(ngModel)]="dojApproverMailId" [value]="dojApproverMailId">
          <mat-option *ngFor="let est of emailArray" [value]="est.id"> {{ est.value }} </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="row" *ngIf="jb_message_true" style="padding-left: 30px" id="jbmsg">
      <h5 class="marginicon40 h4Header marT8 float-right marR16" id="jbmsg2" style="color: red">{{ jb_message }}</h5>
    </div>
    <div class="row" *ngIf="jb_sb_message" style="padding-left: 30px" id="jbSbmsg">
      <h5 class="marginicon40 h4Header marT8 float-right marR16" id="jbSbmsg" style="color: green">
        {{ updated_jbSb_msg }}
      </h5>
    </div>
    <div class="row" style="padding: 15px" id="jb_1">
      <div
        class="col-md-3 mt-1"
        id="checkbox_jb"
        style="padding: 15px"
        *ngIf="il_check || (compHiringType == 4 && !hideJb)"
      >
        <section class="example-section" id="jb_section">
          <mat-checkbox
            id="jb_check"
            [disabled]="disableJB"
            class="example-margin"
            (change)="onChange($event)"
            [checked]="add_jb"
            >Add Joining Bonus (INR)</mat-checkbox
          >
        </section>
      </div>
      <div class="col-md-1" style="border: 1px solid white"></div>
      <div class="col-md-3 mt-1" id="field_jb" *ngIf="add_jb">
        <mat-form-field class="custom-form-field" id="field_jb_">
          <input
            [formControl]="joiningBns"
            required
            id="field_jb__"
            matInput
            type="number"
            placeholder="Joining Bonus"
            name="joining_bonus"
            [(ngModel)]="joiningBonus"
            [value]="joiningBonus"
          />
          <mat-error *ngIf="joiningBns.hasError('required') && compHiringType == 4">
            Joining Bonus is required
          </mat-error>
          <mat-error *ngIf="joiningBns.hasError('invalidNumber') && compHiringType == 4">
            Please enter numerical values
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-5" style="border: 1px solid white"></div>
      <div class="col-md-12" style="padding: 0 15px 10px 15px;" *ngIf="add_jb">
        <mat-radio-group [ngModel]="payoutType()" name="payoutType"
          (ngModelChange)="payoutType.set($event); payoutSelected.set($event === 'one-time' ? 1 : 2)">
          <mat-radio-button value="one-time" style="margin-right: 20px;">One-Time Payout</mat-radio-button>
          <mat-radio-button value="two-time">Two-Time Payout</mat-radio-button>
        </mat-radio-group>
        <p *ngIf="payoutDescription" style="color: red; margin-top: 8px;">{{payoutDescription}}</p>
      </div>
    </div>
    <div class="row" style="padding: 15px" id="sb_1">
      <div class="col-md-3 mt-1" id="checkbox_sb" style="padding: 15px" *ngIf="il_check">
        <section class="example-section" id="sb_section">
          <mat-checkbox
            id="sb_check"
            [disabled]="disableSB || subConSubCheck"
            class="example-margin"
            (change)="onChangeSb($event)"
            [checked]="add_sb"
            >Add Special Bonus (INR)</mat-checkbox
          >
          <p *ngIf="subConSubCheck === true" style="color: red; width: 700px">
            Special bonus cannot be offered to candidates with active source as subsidiary movement/ subcon conversion.
          </p>
        </section>
      </div>
      <div class="col-md-1" style="border: 1px solid white"></div>
      <div class="col-md-3 mt-1" id="field_sb" *ngIf="add_sb">
        <mat-form-field class="custom-form-field" id="field_sb_">
          <input
            matInput
            id="field_sb__"
            [formControl]="specialBns"
            required
            type="number"
            placeholder="Special Bonus"
            [(ngModel)]="specialBonus"
          />
        </mat-form-field>
      </div>
      <div class="col-md-5" style="border: 1px solid white"></div>
    </div>
    <div class="col-md-12 mt-1">
      <mat-form-field class="custom-form-field">
        <mat-label>Remarks</mat-label>
        <input
          id="rem_"
          matInput
          name="remark"
          [(ngModel)]="remarks"
          [value]="remarks"
          (input)="onRemarksChange($event.target.value)"
        />
      </mat-form-field>
    </div>
    <mat-card appearance="outlined" [ngClass]="{ 'error-border': compHiringType == 9 && attachmentId != 280 }">
      <app-attachment
        (fileOutput)="receiveFileOutput($event)"
        (existingFile)="recieveExistingFile($event)"
        [toggleBtn]="toggleBtn"
        [allowedTypes]="allowedTypes"
        [uploadType]="multiple"
        [editId]="editId"
        activityModuleFlag="true"
        [isMapFile]="isMapFile"
      ></app-attachment>
      <div class="mat-caption" *ngIf="compHiringType == 9 && attachmentId != 280" style="padding-left: 4px">
        <mat-error>Offer Letter attachment is mandatory.</mat-error>
      </div>
    </mat-card>
    <div class="col-12">
      <ngb-alert *ngIf="successMessageER" type="success" (close)="successMessageER = null" style="padding-left: 16px">
        <mat-icon style="float: left; line-height: 14px; margin-right: 9px">check_circle_outline</mat-icon>
        {{ successMessageER }}</ngb-alert
      >
      <ngb-alert *ngIf="warningMessageER" type="danger" (close)="warningMessageER = null" style="padding-left: 16px">
        <mat-icon style="float: left; line-height: 14px; margin-right: 9px">highlight_off</mat-icon>
        {{ warningMessageER }}</ngb-alert
      >
      <mat-divider></mat-divider>
    </div>

    <div class="row mt-3" *ngIf="!ifCoupled">
      <div class="col-md-8">
        <div class="row nomarLR padTB16">
          <button
            mat-raised-button
            class="primary-btn btnfullWdth"
            name="updateOfferDetailBtn"
            type="submit"
            [disabled]="isUpdateDisabled()"
            (click)="activityAction()"
            style="width: auto"
          >
            Update
          </button>
          <button
            mat-raised-button
            class="primary-btn btnfullWdth"
            style="width: auto; margin-left: 10px"
            (click)="destroyCard()"
            name="rejectOfferDetail"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </form>
</mat-card-content>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-dialogue propose_letter" data-backdrop="static" data-keyboard="false">
    <div class="modal-header">
      <h5 class="modal-title" id="modal-basic-title-offer-letter">Forward</h5>
      <button type="button" id="close_button_letter" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body wrapper col-md-12 pagesRef">
      <div class="row nomarLR padTB16">
        <div class="col-4 padR8">
          <button
            name="forward_"
            mat-flat-button
            class="secondary-btn btnfullWdth h5Header"
            style="width: 110px; margin-right: 15px"
            (click)="forwardReq(); d('Cross click')"
          >
            Forward
          </button>
        </div>
        <div class="col-4 padL8">
          <button
            name="cancelButton"
            mat-flat-button
            class="secondary-btn btnfullWdth h5Header"
            style="width: 110px; margin-right: 15px"
          >
            Cancel
          </button>
        </div>
      </div>
      <div class="row" style="border: 1px solid white; min-height: 30px"></div>
      <div class="row" style="padding-left: 30px">
        <form class="example-form changingField">
          <mat-form-field class="example-full-width h4Header" style="min-width: 400px">
            <label for="reqId"> Request Id/ Name</label>
            <input
              type="text"
              placeholder=""
              aria-label="Number"
              matInput
              [formControl]="myControl"
              [matAutocomplete]="auto"
              [(ngModel)]="request_Id"
              id="inputrequestid"
              name="reqId"
            />
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
              <mat-option
                *ngFor="let option of filteredOptions | async; let i = index"
                [value]="option.id"
                id="requestoption{{ i }}"
              >
                {{ option.id }}:{{ option.value }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </form>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #dojContent let-c="close" let-d="dismiss">
  <div class="modal-dialogue propose_letter" data-backdrop="static" data-keyboard="false">
    <div class="modal-body wrapper col-md-12 pagesRef">
      <div class="row" style="padding-top: 30px; padding-left: 30px; padding-right: 30px; padding-bottom: 15px">
        Before changing the date of joining, hope you have cross checked with the candidate and launchpad team on
        whether the candidate has joined or not. If the candidate has not joined, click “Ok” to proceed with DOJ
        changes.
      </div>
      <div class="row nomarLR padTB16">
        <div class="col-4 padR8">
          <button
            name="forward_"
            mat-flat-button
            class="secondary-btn btnfullWdth h5Header"
            style="width: 110px; margin-right: 15px"
            (click)="d('Cross click'); dojCheck('ok')"
          >
            Ok
          </button>
        </div>
        <div class="col-4 padL8">
          <button
            name="cancelButton"
            mat-flat-button
            class="secondary-btn btnfullWdth h5Header"
            style="width: 110px; margin-right: 15px"
            (click)="d('Cross click'); dojCheck('cancel')"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
